<div class="table-data-count sdps-m-bottom_small gutter-10">
    <ems-basic-datatable-header-icon class="sdps-pull-left" *ngIf="count > 0 && showHeaderIcons"></ems-basic-datatable-header-icon>

    <div class="table-left" [ngClass]="{'selected-count-top-padding': !showRecords && !showExportBtn, 'table-total-count-border': !showRecords}">
        <div class="sdps-display-inline" *ngIf="count > 0 && selectedCount">
            <span class="sdps-p-left_small">Selected: {{selectedCount}} out of {{count}}</span>
        </div>
        <div class="sdps-display-inline" *ngIf="empIds">
            <span class="sdps-p-left_small">Selected: {{empIds.subAccSelected}}/{{empIds.subAccCount}} Accounts</span>
            <span class="sdps-p-left_small">and {{empIds.empSelected}}/{{empIds.empCount}} Employees</span>
        </div>
        <div class="sdps-display-inline" *ngIf="showTotal && count">
          <span class="sdps-p-left_small">{{ ((groupTotal !== undefined && groupTotal) ? businessUnit ? sharedConst[businessUnit].groupTotalTxt : sharedConst.groupTotalTxt : sharedConst.totalTxt)+ ' ' + count}}</span>
        </div>
      <div class="sdps-display-inline" *ngIf="showTotalForInstrumentGrps">
        <span class="sdps-p-left_small">{{ sharedConst.groupTotalTxt + ' ' + count}}</span>
      </div>      
      <button *ngIf="showExportBtn" type="button" class="buttons sdps-m-right_small sdps-p-bottom_x-small sdps-p-top_x-small" (click)="exportClicked.emit()"
        aria-label="Export Excel">{{sharedConst.manageEmployeeActionItems.exportExcel}}</button>
      <div class="sdps-display-inline" *ngIf="showTotalForSecurities">
        <span class="sdps-p-left_small">{{ sharedConst.securitiesTotalTxt + ' ' + count}}</span>
      </div>
    </div>
    <div class="table-right" *ngIf="showRecords && !viewHistory">
        <div class="no-of-records">
            <span class="sdps-p-right_small">Show</span>
            <p-select class="show-records-select" [ariaLabel]="'Records per page'" [options]="dataList" [(ngModel)]="selectedDropDownVal" (onChange)="noOfRecordsToDisplay($event.value)" ></p-select>
            Records
        </div>
    </div>
    <div class="table-right" *ngIf="showRecords && viewHistory">
        <div class="no-of-records">
            <span class="sdps-p-right_small">Show</span>
            <p-select class="show-records-select" [ariaLabel]="'Records per page'" [options]="dataList" [(ngModel)]="selectedDropDownHistoryVal" (onChange)="noOfRecordsToDisplay($event.value)" ></p-select>
            Records
        </div>
    </div>
    <p class="sdps-clearfix no-margin"></p>
</div>
